function handlePromoDisplay() {
  const promoText = document.getElementById('promotion-text-container');
  const mobilePromoText = [...document.querySelectorAll('#promotion-text-container-m')]
    .find(el => getComputedStyle(el.parentElement).display !== 'none');
  if (!promoText && !mobilePromoText) return;
  const checkForPromo = promoText.querySelector('.fs-custom-single-promo');
  const checkForPromoM = mobilePromoText?.querySelector('.fs-custom-single-promo');
  if (!checkForPromo || !checkForPromoM) {console.log('No promo text found'); return;}
  const allApplicablePromos = promoText.querySelectorAll('.fs-custom-single-promo');
  const allApplicableMobilePromos = mobilePromoText.querySelectorAll('.fs-custom-single-promo');
  let activePromoFound = false;

  
  const getCurrentUTCTime = () => {
    const now = new Date();
    return now.toISOString();
  }
  
  const getStartTime = (startTime) => {
    const start = new Date(`${startTime}`);
    return start.toISOString();
  }
  
  const getEndTime = (endTime) => {
    const end = new Date(`${endTime}`);
    return end.toISOString();
  }
  
  const isPromoActive = (start, end, persist) => {
    //debugger;
    if (persist == "true") { return true };
    const currentTime = getCurrentUTCTime();
    const startTime = getStartTime(start);
    const endTime = getEndTime(end);
    let isActive = currentTime >= startTime && currentTime <= endTime? true : false;
    return isActive;
  }

    // Push promo data to LD+JSON
    const pushPromoDataToLDJSON = (activePromo) => {
      const ldJsonElement = document.getElementById('product-ld-json');
      if (!ldJsonElement) return;
    
      const ldJsonData = JSON.parse(ldJsonElement.textContent);
      const promoData = {
        "price": parseFloat(activePromo.getAttribute('data-promo-price').replace('$', '')),
        "priceCurrency": "USD",
        "@type": "UnitPriceSpecification"
      };
    
      if (ldJsonData.offers && Array.isArray(ldJsonData.offers)) {
        ldJsonData.offers.forEach(offer => {
          if (offer.priceSpecification && Array.isArray(offer.priceSpecification)) {
            const exists = offer.priceSpecification.some(spec => 
              spec.price === promoData.price && spec.priceCurrency === promoData.priceCurrency
            );
    
            if (!exists) {
              offer.priceSpecification.push(promoData);
            }
          }
        });
      }
    
      ldJsonElement.textContent = JSON.stringify(ldJsonData, null, 2);
    };

    for (let i = 0; i < allApplicablePromos.length; i++) {
      const currPromo = allApplicablePromos[i];
      const currPromoStart = currPromo.getAttribute('data-start-time');
      const currPromoEnd = currPromo.getAttribute('data-end-time');
      const currPromoPersist = currPromo.getAttribute('data-promo-continue');
      const currPromoInAppOnly = currPromo.getAttribute('data-app-only');
      const currPromoNotInApp = currPromo.getAttribute('data-not-in-app');
      const currPromoUtmParams = currPromo.getAttribute('data-utm-params');

        // Get current URL query parameters
        const urlParams = new URLSearchParams(window.location.search);
        const isInApp = ((urlParams.get('app') || '').trim().toLowerCase()).startsWith('kinn');
  
        // Check app-specific conditions
        if (isInApp && currPromoNotInApp === 'true') continue;
        if (!isInApp && currPromoInAppOnly === 'true') continue;

        const isGlobalEActive =
          document.body?.getAttribute('ge-active') === 'true';

        const isHiddenForGlobalE =
          currPromo.classList.contains('ge-hide-display-none');

        if (isGlobalEActive && isHiddenForGlobalE) {
          currPromo.style.display = 'none';

          if (allApplicableMobilePromos[i]) {
            allApplicableMobilePromos[i].style.display = 'none';
          }

          continue;
        }

        // Handle UTM parameter validation
        if (currPromoUtmParams) {
          let utmArr = currPromoUtmParams.split(',');
          let hasMatchingUtm = false;
  
          // Check if any UTM combination matches
          for (let utmCombo of utmArr) {
            const utmPairs = utmCombo.split('&');
            const allPairsMatch = utmPairs.every(pair => {
              const [key, value] = pair.trim().split('=');
              return urlParams.get(key) === value;
            });
            
            if (allPairsMatch) {
              hasMatchingUtm = true;
              break;
            }
          }
  
          if (!hasMatchingUtm) continue;
        }


      if (isPromoActive(currPromoStart, currPromoEnd, currPromoPersist)) {
        activePromoFound = true;
        if (window.innerWidth > 768) {
          allApplicablePromos[i].style.display = 'block';
          //pushPromoDataToLDJSON(allApplicablePromos[i]);
        } else {
          allApplicableMobilePromos[i].style.display = 'block';
          //pushPromoDataToLDJSON(allApplicableMobilePromos[i]);
        }

        break;
      }
    }
};

  document.addEventListener('DOMContentLoaded', () => {
    handlePromoDisplay();

    const globalEObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'ge-active'
        ) {
          handlePromoDisplay();
        }
      });
    });

    globalEObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['ge-active']
    });

    const quickviewElements = document.querySelectorAll('.product_quickview');

    if (quickviewElements.length === 0) {
      console.warn('No elements with class "product_quickview" found.');
      return; // Exit if no elements are found
    }

  
    // Set up a MutationObserver for each product_quickview element
    quickviewElements.forEach(quickview => {
      //debugger;
      const observer = new MutationObserver(mutations => {
        //debugger;
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            
            if (quickview.classList.contains('active')) {
              setTimeout(() => {
                handlePromoDisplay();
              }, 300);
            }
          }
        });
      });
  
      observer.observe(quickview, { attributes: true });
    });
  });

handlePromoDisplay();

(() => {
    function parseRules(str) {
      if (!str || !str.trim()) return [];
      str = str.replace(/&amp;/g, '&');
      return str
        .split(',')
        .map((r) => r.trim())
        .filter(Boolean)
        .map((rule) =>
          rule
            .split('&')
            .map((p) => p.trim())
            .filter(Boolean)
            .map((p) => {
              const [k, v] = p.split('=');
              return [k?.trim(), v?.trim()];
            })
            .filter(([k, v]) => k && v)
        )
        .filter((pairs) => pairs.length);
    }

    function ruleMatches(rulePairs, params) {
      for (const [k, v] of rulePairs) {
        if (params.get(k) !== v) return false;
      }
      return true;
    }

    function applyUtmVisibility() {
      const params = new URLSearchParams(location.search);
      const blocks = document.querySelectorAll('.fs-custom-single-promo');
      const containers = new Set();

      blocks.forEach((el) => {
        const rulesStr = el.getAttribute('data-utm-params') || '';
        const rules = parseRules(rulesStr);
        if (!rules.length) {
          containers.add(el.closest('#promotion-text-container, #promotion-text-container-m'));
          return;
        }

        const ok = rules.some((rule) => ruleMatches(rule, params));
        if (!ok) {
          el.style.display = 'none';
          el.setAttribute('data-hidden-by-utm', '1');
        }
        containers.add(el.closest('#promotion-text-container, #promotion-text-container-m'));
      });

      containers.forEach((c) => {
        if (!c) return;
        const anyVisible = [...c.querySelectorAll('.fs-custom-single-promo')].some(
          (e) => getComputedStyle(e).display !== 'none'
        );
        if (!anyVisible) c.style.display = 'none';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyUtmVisibility);
    } else {
      applyUtmVisibility();
    }
})();

(() => {
    const scope = document.querySelector('#promotion-text-container, #promotion-text-container-m') || document;
    scope.querySelectorAll('.promo-coupon-copy').forEach((btn) => {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const code = btn.getAttribute('data-coupon') || '';
        if (!code) return;

        try {
          await navigator.clipboard.writeText(code);
        } catch (err) {
          const ta = document.createElement('textarea');
          ta.value = code;
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          ta.remove();
        }

        const copied = btn.parentElement?.querySelector('.promo-copied');
        btn.style.opacity = '0.4';
        if (copied) copied.style.display = 'inline-block';

        setTimeout(() => {
          btn.style.opacity = '1';
          if (copied) copied.style.display = 'none';
        }, 1200);
      });
    });
})();